import pluralCheck from '@app/utils/string/pluralCheck';

type ActiveStateProps = {
    fileCount: number;
};

export const ActiveState = ({ fileCount }: ActiveStateProps) => (
    <p>
        Upload {fileCount} file{pluralCheck(fileCount)}
    </p>
);

export default ActiveState;
